import { render, staticRenderFns } from "./TimeCommitmentPage.vue?vue&type=template&id=59d36e5a&scoped=true"
import script from "./TimeCommitmentPage.vue?vue&type=script&lang=js"
export * from "./TimeCommitmentPage.vue?vue&type=script&lang=js"
import style0 from "./TimeCommitmentPage.vue?vue&type=style&index=0&id=59d36e5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d36e5a",
  null
  
)

export default component.exports